import { useRef } from '../lib/teact/teact';

export function useStateRef<T>(value: T) {
  const ref = useRef<T>(value);
  ref.current = value;
  return ref;
}
